export default [
    {
        path: '/',
        name: 'home',
        component: () => import('@/pages/Home/Home.vue'),
        meta: {
            auth: false,//需要登录效验
        },
        // redirect: 'index',//路由重定向
        // children: [
        //     {
        //         path: '/index',
        //         name: 'index-page',
        //         component: () => import('@/pages/IndexPage/IndexPage.vue'),
        //         meta: {
        //             auth: false,//需要登录效验
        //         },
        //     },
        // ]
    },
];
